// Module
var code = `<div data-bind="css: model.cssClasses.root">
  <!-- ko template: { foreach: model.renderedActions } -->
  <!-- ko component: { name: 'svc-toolbox-tool', params: { item: \$data, creator: \$root.creator, model: \$parent.model, isCompact: false } } -->
  <!-- /ko -->
  <!-- /ko -->
</div>`;
// Exports
export default code;